module.exports = __webpack_public_path__ + "images/ai_recommendations/xmark-5eda350929d6803b2a4dc0426b630d26.svg";